<template>
  <div class="h-full w-full flex flex-col relative">
    <div class="flex-1 bg-[#28254D] dark:bg-surface-800">
      <div id="cy" class="h-full"></div>
    </div>
    <div
      class="absolute bottom-0 left-0 w-full content-end transition-all overflow-auto pointer-events-none"
      :class="
        queryStore.tabValue === 'query' ||
        (queryStore.tabValue === 'chat' && queryStore.joinStack.data.length > 0)
          ? 'h-[10rem]'
          : 'h-0'
      "
    >
      <div
        v-if="queryStore.joinStack.data.length === 0"
        class="whitespace-nowrap w-fit min-w-full italic text-muted-color p-3 bg-surface-0 dark:bg-surface-900 h-[5rem] leading-[3.5rem] pointer-events-auto border-t border-surface-200 dark:border-surface-700"
      >
        Select a Node or Edge from the graph to start the query
      </div>
      <CytoQueryBuilder
        v-else
        v-model="queryStore.joinStack.data"
        class="pointer-events-auto"
      />
    </div>
  </div>
</template>

<script setup>
import { onMounted } from "vue";

import CytoQueryBuilder from "@/components/cyto_graph_components/CytoQueryBuilder.vue";
import { useQueryStore } from "@/stores/queryStore.js";

const queryStore = useQueryStore();

onMounted(() => {
  let container = document.getElementById("cy");
  queryStore.initCy(container);
});
</script>

<style scoped></style>
